// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"6ab8bedfef797f7ebf93","966":"62a5b45e6d4e022d7d4b"}[chunkId] + ".js";
};